(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ResultRangeDeleteController',ResultRangeDeleteController);

    ResultRangeDeleteController.$inject = ['$uibModalInstance', 'entity', 'ResultRange'];

    function ResultRangeDeleteController($uibModalInstance, entity, ResultRange) {
        var vm = this;

        vm.resultRange = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ResultRange.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
